/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespHeroCarouselRequestMoreImages_item$ref = any;
export type VimeoVideoStatus = "available" | "generic_error" | "not_found" | "not_found_error" | "quota_exceeded" | "transcoding" | "transcoding_error" | "uploading" | "uploading_error" | "%future added value";
export type PdpRespHeroCarousel_item$ref = any;
export type PdpRespHeroCarousel_item = {
    readonly isJewelry: boolean | null;
    readonly defaultSkuId: string | null;
    readonly isMultiSku: boolean;
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly alt: string | null;
    } | null> | null;
    readonly viewInRoomPhotos: ReadonlyArray<{
        readonly src: string | null;
        readonly credits: string | null;
        readonly srcSetProps: {
            readonly sizes: string | null;
            readonly srcSet: string | null;
        } | null;
        readonly centerPosition: {
            readonly top: string | null;
            readonly left: string | null;
        } | null;
        readonly comparatorWidth: {
            readonly pixel: string | null;
            readonly inches: string | null;
        } | null;
    } | null> | null;
    readonly measurement: {
        readonly convertedMeasurements: {
            readonly width: string | null;
            readonly height: string | null;
        } | null;
        readonly hoverDimensionsWidth: ReadonlyArray<{
            readonly unit: string | null;
            readonly value: string | null;
        } | null> | null;
        readonly hoverDimensionsHeight: ReadonlyArray<{
            readonly unit: string | null;
            readonly value: string | null;
        } | null> | null;
    } | null;
    readonly videoVimeo: {
        readonly thumbnail: string | null;
        readonly status: VimeoVideoStatus | null;
        readonly vimeoId: string | null;
    } | null;
    readonly sortedPhotos: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly largePath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly alt: string | null;
        readonly sortOrder: number | null;
        readonly imageSkuXrefs: ReadonlyArray<{
            readonly skuId: string | null;
        } | null> | null;
    } | null> | null;
    readonly address: {
        readonly isGalleryRoomAddress: boolean | null;
    } | null;
    readonly " $fragmentRefs": PdpRespHeroCarouselRequestMoreImages_item$ref;
    readonly " $refType": PdpRespHeroCarousel_item$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "largePath",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alt",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "unit",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "value",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isJewelry",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "defaultSkuId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isMultiSku",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "viewInRoomPhotos",
      "storageKey": null,
      "args": null,
      "concreteType": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "src",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "credits",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "srcSetProps",
          "storageKey": null,
          "args": null,
          "concreteType": "viewInRoomPhotosSrcSet",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "sizes",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "srcSet",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "centerPosition",
          "storageKey": null,
          "args": null,
          "concreteType": "viewInRoomPhotosCenterPosition",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "top",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "left",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "comparatorWidth",
          "storageKey": null,
          "args": null,
          "concreteType": "viewInRoomPhotosComparatorWidth",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pixel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "inches",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "measurement",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedMeasurements",
          "storageKey": "convertedMeasurements(unit:\"IN\")",
          "args": [
            {
              "kind": "Literal",
              "name": "unit",
              "value": "IN"
            }
          ],
          "concreteType": "ItemConvertedMeasurementsType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "width",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "height",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "hoverDimensionsWidth",
          "name": "display",
          "storageKey": "display(addLabel:false,fields:[\"width\"])",
          "args": [
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "width"
              ]
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "plural": true,
          "selections": (v4/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "hoverDimensionsHeight",
          "name": "display",
          "storageKey": "display(addLabel:false,fields:[\"height\"])",
          "args": [
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "height"
              ]
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "plural": true,
          "selections": (v4/*: any*/)
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "videoVimeo",
      "storageKey": null,
      "args": null,
      "concreteType": "VideoVimeo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "thumbnail",
          "args": [
            {
              "kind": "Literal",
              "name": "includePlayButton",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "pad",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "size",
              "value": "w100h75"
            }
          ],
          "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "vimeoId",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sortedPhotos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sortOrder",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "imageSkuXrefs",
          "storageKey": null,
          "args": null,
          "concreteType": "ImageSkuXref",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "skuId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "address",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isGalleryRoomAddress",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_item",
      "args": null
    }
  ]
};
})();
(node as any).hash = 'ec93877e5bab2a500895399e229af7be';
export default node;
